export const RECEIVE_AFFINITY_SUGGESTIONS = "RECEIVE_AFFINITY_SUGGESTIONS"
export const CLEAR_AFFINITY_SUGGESTIONS = "CLEAR_AFFINITY_SUGGESTIONS"
export const FETCH_AFFINITY_SUGGESTIONS = "FETCH_AFFINITY_SUGGESTIONS"
export const TOGGLE_PROFILE_DRAWER_SAVING_ON = "TOGGLE_PROFILE_DRAWER_SAVING_ON"
export const TOGGLE_PROFILE_DRAWER_SAVING_OFF = "TOGGLE_PROFILE_DRAWER_SAVING_OFF"
export const OPEN_PROFILE_AVATAR = "OPEN_PROFILE_AVATAR"
export const CLOSE_PROFILE_AVATAR = "CLOSE_PROFILE_AVATAR"
export const TOGGLE_EDIT_PROFILE_ON = "TOGGLE_EDIT_PROFILE_ON"
export const TOGGLE_EDIT_PROFILE_OFF = "TOGGLE_EDIT_PROFILE_OFF"
export const DELETE_ALL_USER_EXPERIENCES = "DELETE_ALL_USER_EXPERIENCES"
export const CLAIM_ZOOM_PROFILE = "CLAIM_ZOOM_PROFILE"
export const DELETE_CLAIMED_ZOOM_PROFILE = "DELETE_CLAIMED_ZOOM_PROFILE"
export const INVITE_TO_ZOOM = "INVITE_TO_ZOOM"
export const UPDATE_CURRENT_USER = "UPDATE_CURRENT_USER"
export const UPDATE_POSITION = "UPDATE_POSITION"
export const CREATE_POSITION = "CREATE_POSITION"
export const DELETE_POSITION = "DELETE_POSITION"
export const UPDATE_DEGREE = "UPDATE_DEGREE"
export const CREATE_DEGREE = "CREATE_DEGREE"
export const DELETE_DEGREE = "DELETE_DEGREE"
export const SAVE_AVATAR = "SAVE_AVATAR"
export const ADD_USER_AFFINITY = "ADD_USER_AFFINITY"
export const RECEIVE_UPDATE_USER_CONSTITUENT = "RECEIVE_UPDATE_USER_CONSTITUENT"
export const DELETE_USER_AFFINITY = "DELETE_USER_AFFINITY"
export const ADD_USER_RELATIONSHIP = "ADD_USER_RELATIONSHIP"
export const DELETE_USER_RELATIONSHIP = "DELETE_USER_RELATIONSHIP"
export const RECEIVE_UPDATE_USER = "RECEIVE_UPDATE_USER"
export const FETCH_INDUSTRY_SUGGESTIONS = "FETCH_INDUSTRY_SUGGESTIONS"
export const CLEAR_INDUSTRY_SUGGESTIONS = "CLEAR_INDUSTRY_SUGGESTIONS"
export const RECEIVE_INDUSTRY_SUGGESTIONS = "RECEIVE_INDUSTRY_SUGGESTIONS"

export const receiveAffinitySuggestions = (affinitySuggestions) => ({
  type: RECEIVE_AFFINITY_SUGGESTIONS,
  affinitySuggestions,
})

export const fetchAffinitySuggestions = (query) => ({
  type: FETCH_AFFINITY_SUGGESTIONS,
  query,
})

export const clearAffinitySuggestions = () => ({
  type: CLEAR_AFFINITY_SUGGESTIONS,
})

export const toggleProfileDrawerSavingOn = () => ({
  type: TOGGLE_PROFILE_DRAWER_SAVING_ON,
})

export const openProfileAvatar = () => ({
  type: OPEN_PROFILE_AVATAR,
})
export const closeProfileAvatar = () => ({
  type: CLOSE_PROFILE_AVATAR,
})

export const toggleProfileDrawerSavingOff = () => ({
  type: TOGGLE_PROFILE_DRAWER_SAVING_OFF,
})

export const toggleEditProfileOn = () => ({
  type: TOGGLE_EDIT_PROFILE_ON,
})

export const toggleEditProfileOff = () => ({
  type: TOGGLE_EDIT_PROFILE_OFF,
})

export const deleteAllUserExperiences = (experienceType, success, error) => ({
  type: DELETE_ALL_USER_EXPERIENCES,
  experienceType,
  success,
  error,
})

export const claimZoomProfile = (success, error) => ({
  type: CLAIM_ZOOM_PROFILE,
  success,
  error,
})

export const deleteClaimedZoomProfile = (success, error) => ({
  type: DELETE_CLAIMED_ZOOM_PROFILE,
  success,
  error,
})

export const inviteToZoom = (params, success, error) => ({
  type: INVITE_TO_ZOOM,
  params,
  success,
  error,
})

export const receiveUpdateUserConstituent = (currentConstituent) => ({
  type: RECEIVE_UPDATE_USER_CONSTITUENT,
  currentConstituent,
})

export const updateCurrentUser = (currentUser, success, error) => ({
  type: UPDATE_CURRENT_USER,
  currentUser,
  success,
  error,
})
export const updatePosition = (position, success, error) => ({
  type: UPDATE_POSITION,
  position,
  success,
  error,
})

export const deletePosition = (position, error) => ({
  type: DELETE_POSITION,
  position,
  error,
})

export const deleteUserAffinity = (affinityId, error) => ({
  type: DELETE_USER_AFFINITY,
  affinityId,
  error,
})

export const deleteUserRelationship = (relationshipId, error) => ({
  type: DELETE_USER_RELATIONSHIP,
  relationshipId,
  error,
})

export const addUserRelationship = (relationship, success, error) => ({
  type: ADD_USER_RELATIONSHIP,
  relationship,
  success,
  error,
})

export const createPosition = (position, success, error) => ({
  type: CREATE_POSITION,
  position,
  success,
  error,
})

export const updateDegree = (degree, success, error) => ({
  type: UPDATE_DEGREE,
  degree,
  success,
  error,
})

export const deleteDegree = (degree, error) => ({
  type: DELETE_DEGREE,
  degree,
  error,
})

export const createDegree = (degree, success, error) => ({
  type: CREATE_DEGREE,
  degree,
  success,
  error,
})

export const saveAvatar = (img, success, error) => ({
  type: SAVE_AVATAR,
  img,
  success,
  error,
})

export const addUserAffinity = (affinity, success, error) => ({
  type: ADD_USER_AFFINITY,
  affinity,
  success,
  error,
})

export const receiveUpdateUser = (currentUser) => ({
  type: RECEIVE_UPDATE_USER,
  currentUser,
})

export const receiveIndustrySuggestions = (suggestions) => ({
  type: RECEIVE_INDUSTRY_SUGGESTIONS,
  suggestions,
})

export const fetchIndustrySuggestions = (query) => ({
  type: FETCH_INDUSTRY_SUGGESTIONS,
  query,
})

export const clearIndustrySuggestions = () => ({
  type: CLEAR_INDUSTRY_SUGGESTIONS,
})
